<template>
    <section class="quick" v-if='list.length != 0'>
        <header-com class='bgw'>
            <div class="location" v-if='list.length != 0'>
                <span class="f26">所有养护方案均以实物诊断为准</span>
            </div>
        </header-com>
        <div v-for='(item,index) in list' :key='index'>
            <div class='line_bg'></div>
            <div class='content_card'>
                
                <div class="title f32">
                    <div class="block"></div>
                    <span>{{changeTitleText(item.categoryText)}}</span>
                </div>
                <div v-for='(ele,idx) in item.shoppingBagBoList' :key='idx'>
                    <div class='brandTitle' v-if='ele.brand'>
                        <img :src='"/images/newOrder/"+getBrandImg(item.categoryId)+".png"'>
                        <div>{{ele.brand}}</div>
                    </div>
                    <div class='service_list' v-for='(data,dataIndex) in ele.shoppingCuringServiceBoList' :key='dataIndex'>
                        <radio1 class='radiosd' :checked='data.selected == 1' v-if='!enoughNowTag' @changeRadio='changeRadio(data.shoppingCartId,data.selected)'></radio1>
                        <list-item-new :type='2' :service='data' :enoughNowTag='enoughNowTag' style='margin-bottom:20px;margin-top:20px' :class='{marginL:enoughNowTag}' @select='changeSpecifications' @changeRadio='toDetailService'/>
                    </div>
                </div>
            </div>
        </div>
        
        <div class='line_bg' v-if='!consultation'></div>
        <div class='content_card' v-if='!consultation'>
            <div class="title f32">
                <div class="block"></div>
                <span>养护数量</span>
                <div class='choseNum' @click='show = true'>
                    <span>{{defaultIndex}}{{unit}}</span>
                    <img src='/images/public/arrow-right.png'>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                </div>
            </div>
  
            <field @changeMessage='changeMessage'></field>
        </div>
        <div class='line_bg' v-if='!consultation'></div>
        <div class='content_card'>
            <div class="title f32">
                <div class="block"></div>
                <span>常见问题</span>
            </div>
            <question></question>
        </div>

        <div class="g-fixed-bottom">
            <div>
                <div class='bagit_cont'>
                    
                   方案金额
                
                </div>
                <div class='price' v-if='detail.orderAmount !== 0'>¥{{detail.orderAmount?detail.orderAmount:'--'}}</div>
                <div class='price' v-else>¥{{detail.orderAmount}}</div>
            </div>
            <div v-if='!consultation' class='flex_end'>
                <!-- <button class="secondary">加入方案</button> -->
                <img src='/images/public/bag_del.png' class='del_img' @click='delBag' v-if='!enoughNowTag'>
                <button class="primary margin0"  @click='submitCart'>{{btnText}}</button>
            </div>
        </div>

     
        <van-popup v-model="show" position="bottom" :overlay="true" >
            <div class="containerAdr f28 paddingBottom">
                <div class="ctitle">请选择您的品类数量</div>
                <!-- <span @click="$router.push({ name: 'addressEdit'})">添加地址</span> -->
                <div class="close" @click="show = false"></div>
                <div class='category_list'>
                <div v-for='(item,index) in categoryList' :key='index'>
                        <img :src="'/images/newOrder/'+item.imgPath+'.png'" v-show='!item.num'>
                        <img :src="'/images/newOrder/'+item.imgPath+'1.png'" v-show='item.num'>
                        <span>{{item.name}}</span>
                        <num-count 
                            style="margin-top:5px;"
                            :num='item.num'
                            :large='false'
                         
                            @plus='plus(index)'
                            @minus='minus(index)'
                        >
                        </num-count>
                    </div>
                </div>
               
                <div class='categoty_tips'>
                    *请选择您需要养护的品类数量，至少选择一个品类
                </div>
                 <div class="g-fixed-bottom">
                     <div></div>
                    <div class='homeBtn'>
            
                        <button class="primary" style='margin-right:0' :disabled='submitNumJi == 0' @click='submitNum()'>确认</button>
                    </div>
                </div>
                
            </div>

           
        </van-popup>

        <van-popup position="bottom" v-model="specificationsShow" overlay-class='layer'>
            <div class="containerExpree f28">
                <div class="title">{{indetail.name}}</div>

                <div class="close" @click="specificationsShow = false"></div>
                <div class='detail_content'>
                    <img :src="specificationList[selectSpecificationIndex].curingServiceImagesBoList[0]['pic'] | formatImgUrl(700,700,true)" class='detail_img'/>
                    <div>
                        <div>
                            <div class='detail_price'>¥{{specificationList[selectSpecificationIndex].price}}</div>
                            <div class='detail_sail'>{{indetail.content}}</div>
                        </div>
                        <div class='fr'>
                            <num-count
                                :num='servceNum'
                                @plus='servceNum++'
                                @minus='servceNum > 1 ? servceNum-- : servceNum = 1'
                            />
                        </div>
                    </div>
                </div>
                <div class='detail_title'>
                    规格
                </div>
                <div class="specification">
                    <ul>
                        <li v-for="(item,index) in specificationList"
                            :key="index"
                            :class="{'active':selectSpecificationIndex === index}"
                            @click="setIndex(index,item.name)">{{item.name}}</li>
                    </ul>
                </div>
                <div class="g-fixed-bottom">
                    <div>
                        
                    </div>
                    <div>
                        <button class="primary margin0" @click='submitSelectSpecification'>确定</button>
                    </div>
                </div>
            </div>
        </van-popup>
    </section>

    <section class="quick" v-else>
        <header-com></header-com>
        <img src='/images/newOrder/bagnolist.png' class='no_list_bg'>
        <div class='mt60' v-if='!consultation && !consultationId'>
            <button class="primary" @click="$router.push({name:'homeListNew'})">去选购</button>
        </div>

    </section>
</template>

<script>
  import homeApi from '@/axios/home'
  import publicObj from '@/assets/js/public';
  import { Toast,Dialog } from 'vant';
  import myApi from '@/axios/my';
  import wxShare from "@/assets/js/wx.share"
  import zhugeObj from '@/assets/js/track'
  import orderApi from '@/axios/order'

  export default {
    name: 'index',
    data () {
      return {
        categoryList : [
            {
                imgPath : 'package',
                name : '包包',
                key : 3,
                num : 0
            },
            {
                imgPath : 'shoes',
                name : '鞋靴',
                key : 4,
                num : 0
            },
            {
                imgPath : 'pajamas',
                name : '衣裤',
                key : 5,
                num : 0
            },
            {
                imgPath : 'accessories',
                name : '配饰',
                key : 6,
                num : 0
            },
        ],
        serviceList : [],
        specificationsShow : false,
        message : '',
        list : [],
  
        show : false,
        defaultIndex : '请选择',
        detail : {},
        specificationList: [{
            salesNumber : 0,
            curingServiceImagesBoList : [{pic:""}]
        }],
        selectSpecificationIndex : 0,
        servceNum : 1,
        shoppingCartId : '',
        enoughNowTag : false,
        enoughNow:{
          curingServiceId : ''
        },

        consultation : false,
     
        curingServiceSourceId : '',
        unit : '',
        indetail : {},
        consultationId : '',
        isbind :false,
        teamId : '',
        isTeam : ''
      }
    },
    computed: {
        submitNumJi(){
            let num = 0;
            this.categoryList.forEach((item,index)=>{
                num += item.num;
            })
       
            return num;
        },
        btnText(){
            if(this.teamId || this.isTeam){
                return '确认拼团'
            }else{
                return '下一步'
            }
        },
        defultAdr(){
            let items = '';
            this.adrList.forEach((item,index)=>{
                if(item.isDefault){
                    items = item;
                }
            })
            if(items){
                return items;
            }else{
                return {};
            }
        },
        disable(){
            let ids = [];
            let flag = false;
            this.list.forEach((item,index)=>{
                item.shoppingBagBoList.forEach((ele,idx)=>{
                    ele.shoppingCuringServiceBoList.forEach((data,dataIndex)=>{
                        if(data.selected){
                            ids.push(data.shoppingCartId);
                        }
                        console.log(data.curingServiceId)
                        if(!data.curingServiceId){
                            flag = true;
                        }
                    })
                })  
            })
            if(flag){
                return true;
            }
            if(ids.length == 0){
                return true;
            }

            if(this.defaultIndex == '请选择'){
                return true;
            }
            if(this.type == 40){
                if(JSON.stringify(this.defultAdr) == '{}'){
                    return true;
                }
                //少一个上门时间的验证
            }

            return false;

        }
    },
    created() {
      
        if(this.$route.query.curingServiceId){
            this.enoughNow = {
                curingServiceId : this.$route.query.curingServiceId,
                buyQuantity : this.$route.query.buyQuantity
            }
            this.enoughNowTag = true;
            this.teamId = this.$route.query.teamId;
            this.isTeam = this.$route.query.isTeam;
        }

        if(this.$route.query.bind){
           this.isbind = true;
           this.bindConsultation();
      
           return;
        }


        if(this.$route.query.consultation){
            this.getconsultation(this.$route.query.consultation);
            this.consultation = true;
            
            return;
        }
     
        this.getBagList();

    },
    mounted(){
        
    },
    methods: {
        changeTitleText(text){
            if(this.isTeam || this.teamId){
                return '拼团'
            }else{
                return text;
            }
        },
        formatImgUrl(url, width, height,m_fill) {
            if(url.length < 40){
                return url;
            }
            if (url) {
                url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
                // url = url.replace(',jpg', ",webp");
                url +=',q_80';
            if(m_fill){
                    // console.log(m_fill)
                    url = url.replace('m_lfit', "m_fill");
                }
            }
            return url
        },
        plus(index){
            this.categoryList[index].num++;
            // this.submitNum();
        },
        minus(index){
            this.categoryList[index].num? this.categoryList[index].num-- : this.categoryList[index].num = 0 
            // this.submitNum();
        },
        changeMessage(mes){
            this.message = mes;
        },
        changepayTypeOther(index){
            this.type = index;
        },
        getBrandImg(index){
            if(index == 3){
                return 'package1'
            }else if(index == 4){
                return 'shoes1'
            }else if(index == 5){
                return 'pajamas1'
            }else{
                return 'accessories1'
            }
        },
 
        bindConsultation(){
            let _this = this;
            this.consultationId = this.$route.query.consultation;
            
            //调用绑定接口，回调记得获取用户购物袋和地址

            let sendCid = this.$route.query.sendCid;
            if(sendCid == this.$store.state.customerId){
                this.getconsultation(this.$route.query.consultation);
                this.consultation = true;
                return;
            }
            homeApi.consultationCheck(this.consultationId).then((res)=>{
                this.getBagList();
                zhugeObj.track({
                    title : '购物车-方案袋分享绑定',
                })
            }).catch((res)=>{
          
                this.$router.push({name:'homeIndex'})
            })
        },
        setShare(){
            let consultation = this.$route.query.consultation;
            // console.log(this.list[0].shoppingBagBoList[0].shoppingCuringServiceBoList[0].pic)
            let shareBody = {
                link : location.origin + '/homeBag?consultation='+consultation+'&bind=1&sendCid=' + this.$store.state.customerId,
                title : '【包怎么诊】快来查看你宝贝的初诊方案',
                desc : '确认后预约顺丰上门，签收后可到个人账户查看',
            
            }
            
            if(this.list.length != 0){
                shareBody.imgUrl = this.formatImgUrl(this.list[0].shoppingBagBoList[0].shoppingCuringServiceBoList[0].pic,300,300)
            }
            wxShare(shareBody).then(()=>{
                homeApi.consultationSend(consultation).then((res)=>{
                    
                })
            });
        },
        submitCart(){
            let tag = false;
            this.list.forEach((item,index)=>{
                item.shoppingBagBoList.forEach((ele,idx)=>{
                    ele.shoppingCuringServiceBoList.forEach((data,dataIndex)=>{
                        if(data.selected && !data.curingServiceId && !tag){
                            console.log(data)
                            tag = true;
                            this.changeSpecifications(data,data.shoppingCartId);
                            return;
                        }
                    })
                })
            })

            if(tag){
                Toast('请您选择服务规格');
                return;
            }

            if(this.defaultIndex == '请选择'){
                Toast('请您选择养护数量');
                this.show = true;
                return;
            };

            let params = {
                remarks : this.message,
                action : 'normal',
                categoryRemark : []
            };

            if(this.enoughNowTag){
                params.curingServiceId = this.enoughNow.curingServiceId;
                params.buyQuantity = this.enoughNow.buyQuantity;
                if(this.teamId){
                    params.groupRecordId = this.teamId;
                }
            }
            this.categoryList.forEach((item,index)=>{
                let obj = {};
                obj.id = item.key;
                obj.count = item.num;
                params.categoryRemark.push(obj);
            })
            params.categoryRemark =  JSON.stringify(params.categoryRemark);

                  

            zhugeObj.track({
                title : '方案-确认预约',
                content : {
                    '养护数量' : params.categoryRemark,
                    '特殊需求' : params.remarks
                }
            })   


            let paramsOrder = {
                current : 1,
                size : 1000,
            }
            let orderArr = [];
            orderApi.getBookingsOrder(paramsOrder).then((res)=>{
                // orderArr = res.records.map((item)=>{
                //     return item.stateText
                // })
                let tag = false;
                res.records.forEach((element)=>{
                    if(element.bookingsCuringServiceBoList){
                        if((element.stateText == '待发货' || element.stateText == '待取件' || element.stateText == '待付款') && element.bookingsCuringServiceBoList[0].classify == 10){
                            tag = true;
                        }
                    }
                })
                if(tag){
                    Dialog.confirm({
                        title: '',
                        message: '您有未完结预约单，是否继续预约?',
                        confirmButtonText : '否',
                        cancelButtonText : '是'
                    }).then(() => {
                        // this.addBookingOrder(params); 
                    }).catch(() => {
                        // on cancel
                        this.addBookingOrder(params); 
                    });
                }else{
                    this.addBookingOrder(params); 
                }
               

            })
        
            // console.log(params);
        },
        addBookingOrder(params){
            homeApi.submitCart(params).then((res)=>{
                localStorage.setItem('bagStorage','');
                // if(res.realAmount != 0){
                if(this.teamId || this.isTeam){
                    this.$router.push({name:'pay',query:{id:res.orderCode,type:'active',isTeam:'1'}})
                }else{
                    this.$router.push({name:'pay',query:{id:res.orderCode}})
                }

            }).catch((res)=>{
                if(res.code == 10086){
                    Toast(res.message);
                    return
                }
            })
        },
        submitNum(){
            zhugeObj.track({
                title : '点击-方案确认'
            })   
            let totle = 0;
            let shoreNum = 0;
            
            this.categoryList.forEach((item,index)=>{
                if(item.num){
                    totle += item.num;
                    
                }

                if(item.key == 4){
                    shoreNum = item.num;
                }
            })

            this.unit = '件'
            if(totle == shoreNum){
                this.unit = '双'
            }

            this.defaultIndex = totle;
            if(!this.defaultIndex){
                this.defaultIndex = '请选择';
                this.unit = '';
            }
            this.show = false;
        },
        delBag(){
            Dialog.confirm({
                title: '',
                message: '您确认要删除选中项?'
            }).then(() => {
                let shoppingBagIds = [];
                let ids = [];
                this.list.forEach((item,index)=>{
                    item.shoppingBagBoList.forEach((ele,idx)=>{
                        ele.shoppingCuringServiceBoList.forEach((data,dataIndex)=>{
                            if(data.selected){
                                shoppingBagIds.push(ele.id);
                                ids.push(data.shoppingCartId);
                            }
                        })
                    })  
                })
                

                if(shoppingBagIds.length == 0){
                    Toast('请至少选择一个');
                    return;
                }

                let params = {
                    shoppingBagIds : shoppingBagIds,
                    ids : ids
                }

                zhugeObj.track({
                    title : '方案-删除方案',
                    content : {
                        '删除方案' : '删除',
                        'IDS' : shoppingBagIds
                    }
                })   
                
                // console.log(params)
                homeApi.clearBag(params).then((res)=>{
                    this.getBagList();
                })
            }).catch(() => {
            // on cancel
            });
        },
        changeRadio(shoppingCartId,selected){
            if(this.enoughNowTag || this.consultation){
                return;
            }
            let params = {
                id : shoppingCartId,
                selected : selected?0:1
            }
            Toast.loading({
                message: '拼命加载中...',
                duration: 0,
                forbidClick: true, // 禁用背景点击
                // loadingType: 'spinner',
            })

            homeApi.updataShoppingCart(params).then((res)=>{
                this.getBagList();
                // Toast.clear();
            }).catch(()=>{
                // Toast.clear();
            })
        },
        toDetailService(item){
            this.$router.push({ name : 'serviceDetail' , query:{serviceId:item.curingServiceGoodsId,specificationId:item.curingServiceId}});
        },
        submitSelectSpecification(){
            if(!this.servceNum){
                Toast('请选择数量');
                return;
            }
            let params = {
                id : this.shoppingCartId,
                buyQuantity : this.servceNum,
                curingServiceTargetId : this.specificationList[this.selectSpecificationIndex].id,
                curingServiceSourceId : this.curingServiceSourceId
            }
            
            homeApi.updataShoppingCart(params).then((res)=>{
                this.specificationsShow = false;
                this.getBagList();
                // Toast.clear();
            }).catch(()=>{
                this.specificationsShow = false;
                // Toast.clear();
            })

        },
        setIndex(index){
            this.selectSpecificationIndex = index;
        },
        changeSpecifications(item,shoppingCartId){
            if(this.consultation){
                return;
            }
            this.curingServiceSourceId = item.curingServiceId;

            this.selectSpecificationIndex = 0;
            if(item.buyQuantity){
                this.servceNum = item.buyQuantity;
            }else{
                this.servceNum = 1;
            }
            
            this.shoppingCartId = shoppingCartId;
            homeApi.serviceDetail(item.curingServiceGoodsId).then((res)=>{
                this.indetail = res;
                
                this.specificationList = res.curingServiceWithContentAndImagesBoList;
                this.specificationsShow = true;
                this.specificationList.forEach((ele,idx)=>{
                    
                    if(item.id == ele.id){
                        this.selectSpecificationIndex = idx;
                    }
                })
            })
        },
        onConfirm(value, index){
            this.defaultIndex = value;
            this.show = false;
            if(this.enterComfirm){
                this.submitCart();
            }
        },
        changeType(){
            this.type == 10?this.type = 40:this.type = 10;
            
            this.adrShow = false;
            
        },
        adrClick(index){
            this.adrList.forEach((element,idx) => {
                if(index == idx){
                    element.isDefault = true;
                }else{
                    element.isDefault = false;
                }
            });
            this.adrShow = false;
        },
        
        getBagList(){
            let params = {
                action : 'normal'
            }
            if(this.enoughNowTag){
                params.curingServiceId = this.enoughNow.curingServiceId;
                params.buyQuantity = this.enoughNow.buyQuantity;
            }
            if(this.teamId){
                params.groupRecordId = this.teamId;
            }
            homeApi.getShoppingCart(params).then((res)=>{
                
                this.detail =  res;
                this.list = res.shoppingGoodsBoList;
                if(this.list.length == 0 && this.isbind){
                    this.$router.push({name:'orderList',params:{type:1}})
                }
   

                this.list.forEach((item,index)=>{
                    this.categoryList.forEach((data,dataIndex)=>{

                        data.num = 0;
                        
                        if(item.categoryId == data.key){
                               // 判断是否有品牌
                            item.shoppingBagBoList.forEach((items,indexs)=>{
                                if(items.brandId){
                                   data.num++; 
                                }
                            })
                        }
                    })
                })
                
                this.submitNum();
            })
        },
        getconsultation(id){
            homeApi.consultationOrder(id).then((res)=>{
                
                this.detail =  res;
                this.list = res.shoppingGoodsBoList;

                this.list.forEach((item,index)=>{
          
                    this.categoryList.forEach((data,dataIndex)=>{
                        data.num = 0;
                        if(item.categoryId == data.key){
                            
                            // 判断是否有品牌
                            item.shoppingBagBoList.forEach((items,indexs)=>{
                                if(items.brandId){
                                   data.num++; 
                                }
                            })
                            // data.num = item.shoppingBagBoList.length;
                        }
                    })
                })  

                this.setShare();
                this.submitNum();
            })
        }
    }
  }
</script>

<style scoped lang="scss">
    .homeBtn{
        flex-grow: initial!important;
        flex-shrink: initial!important;
        flex-basis: initial!important;

    }
    .marginL{
        margin-left: -48px;
    }
    .coupon{
        display: flex;
        justify-content: space-between;
        margin-top: 32px;
        border-bottom: 1px dashed #e1e1e1;
        padding-bottom: 40px;
        .payTypeOther{
            display: flex;
            &>div{
                display:flex;
                line-height: 35px;
                margin-left: 40px;
                &>div{
                    margin-left: 10px;
                 
                }
            }
        }
    }
    .flex_end{
        justify-content: flex-end;
        .primary{
            margin-right: 0!important;
        }
    }
    .mt60{
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }
    .no_list_bg{
        width: 100%;
        margin-top: 180px;
    }
    .bgn{
        background: transparent!important;
    }
    .paddingBottom{
        padding-bottom: 180px!important;
    }
    .category_list{
        display: flex;
        justify-content:space-around;
        border-bottom: 1px solid #e1e1e1;
        padding-bottom:28px;
        img{
            width:112px;
            margin-left: 10px;
        }
        &>div{
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            text-align: center;
            vertical-align: middle;
            &>span{
                margin-top: 12px;
                font-size: 28px;
                color:#9B9B9B;
            }
        }
    }
    .categoty_tips{
        color:#9B9B9B;
        font-size: 24px;
     
        margin-top: 30px;
    }
    .title{
        height: 44px;
        width: 690px;
        display: flex;
        align-items: center;
        font-weight:500;
        .block{
            width:8px;
            height:28px;
            background:rgba(122,223,223,1);
            margin-right: 10px;
        }
    }
    .margin0{
        margin-right: 0!important;
    }
    .specification{
        padding:0px 0 100px 0px ;
        // border-bottom:20px #F6F6F6 solid;
        max-height: 400px;
        overflow: scroll;
        div{
            line-height: 54px;
        }
        ul{
            display: flex;
            flex-wrap: wrap;
        li{
            min-width:138px;
            height:54px;
            line-height: 52px;
            box-sizing: border-box;
            padding: 0 20px;
            background:#f8f8f8;
            border-radius:6px;
            border:$base-border;
            text-align: center;
            margin: 0 20px 20px 0;
            font-size: 26px;
            font-weight: normal;
        }
        .active{
            border-color: $brand-color;
            color: #000;
            background: rgba($brand-color,.1);
        }
        }
    }
    .detail_title{
        color:#333;
        font-size: 32px;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    .containerExpree{
        min-height: 380px;
        padding: 30px;
        position: relative;
        .title{
            line-height: 40px;
            margin-bottom: 50px;
            font-size:32px; 
        }
        .close{
            width: 36px;
            height: 36px;
            position: absolute;
            top: 30px;
            right: 30px;
            background: url("/images/public/close.png") no-repeat center;
            background-size: 32px;
        }
    }
    .detail_content{
        display:flex;
        padding-bottom: 40px;
        border-bottom:1px solid #E0E0E0;
        &>div{
            width: 100%;
            flex:1;
            margin-left: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .detail_price{
                color:#F24949;
                font-size: 32px;
                font-weight:500;
                line-height: 55px;
            }
            .detail_sail{
                color:#999999;
                font-size: 28px;
                margin-top: 22px;
            }
        }
        .fr{
            display: flex;
            justify-content: flex-end;
        }
    }
    .detail_img{
        width: 240px;
        height: 240px;
        border-radius:12px;
        border:1px solid rgba(151,151,151,1)
    }
    .margin0{
        margin-right: 0!important;
    }
    .del_img{
        width: 38px;
        height: 36px;
        margin-top: 25px;
        margin-right: 36px!important;
    }
    .bagit_cont{
        line-height: 80px;
    }
    .g-fixed-bottom{
        display: flex;
        justify-content: space-between;
        align-items:center;
        padding-top: 0;
            >div{
                // width: 80px;
                // margin-right: 10px;
                text-align: center;
                display: flex;
                .price{
                    color:#F24949;
                    line-height: 80px;
                    margin-left: 30px;
                    font-size: 26px;
                    font-weight: 500;
                }

            
            p{
                line-height: 28px;
                font-size: 20px;
            }
            .secondary{
                margin-right: 10px;
                margin-top: 3px;
            }
        }
    }
    .expressTypeName{
        line-height: 50px;
    }
     .choseType{
         color:#4A4A4A;
        font-size: 28px;
        display: flex;
        justify-content: flex-end;
        line-height: 28px;
        margin-top: 25px;
        padding-right:50px;
        position: relative;
        .expressTypeTitle{
            color:#4A4A4A;
       
            font-size: 24px;
            line-height: 50px;
        }
        img{
            width:35px;
            position: absolute;
            right: 0;
            top:20px;
        }
    }
    
    .expressType{
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        line-height: 28px;
        padding-right:50px;
        .expressTypeTitle{
            color:#4A4A4A;
            font-weight:600;
            font-size: 28px;
            line-height: 50px;
        }
    }
    .adr{
        display: flex;
        justify-content: flex-end;
        line-height: 28px;
        margin-top: 10px;
        padding-right:50px;
        position: relative;
        // border-bottom: 1px dashed #e1e1e1;
        // padding-bottom: 28px;
        img{
            position: absolute;
            right: 0;
            top:2.5px;
            width: 14px;
        }
    }
    .field{
        margin-top: 20px;
        border:1px solid #e1e1e1;
        border-radius: 4px;
        padding:26px 30px;
        color:#9B9B9B;
        background:rgba(233,233,233,0.3);
        border: none;
        ::-webkit-input-placeholder { /* WebKit browsers */
            color: #9B9B9B;
            font-size: 24px;
        }
    }
    .choseNum{
        position: absolute;
        right:0;
        line-height: 35px;
        display: flex;
        img{
            width: 16px;
            height: 32px;
            margin-top: 3px;
        }
        span{
            margin-right: 40px;
        }
    }
    .radiosd{
        position: absolute;
        top:60px;
        left:0;
    }
    .bgw{
        background: #fff;
    }
    .service_list{
        position: relative;
        padding-left: 50px;
        // display: flex;

    }
    .brandTitle{
        display: flex;
        line-height: 40px;
        margin-top: 40px;
        border-bottom: 1px solid #eee;
        padding-bottom: 30px;
        margin-bottom: 40px;
        img{
            width: 40px;
            height: 42px;
        }
        div{
            padding-left: 12px;
            padding-right: 12px;
            background:rgba(243,251,251,1);
            border:1px solid rgba(122,223,223,1);
            font-size: 24px;
            color:#4a4a4a;
            border-radius:6px;
            margin-left: 20px; 
        }

    }
    .title{
        height: 44px;
        width: 690px;
        display: flex;
        align-items: center;
        font-weight:500;
        position: relative;
        .block{
            width:8px;
            height:28px;
            background:rgba(122,223,223,1);
            margin-right: 10px;
        }
    }
    .content_card{
        background: #fff;
        padding-top: 30px;;
        padding-left:30px;
        padding-right:30px;
        padding-bottom:40px;
        // margin-top:20px;
    }
    .quick{
        padding-top: 100px;
        padding-bottom:110px;
    }
    .line_bg{
        height:20px;
        background: #EDEDED;
    }
    .location{
        position: absolute;
        left: 110px;
        height: 60px;
        display: flex;
        align-items: center;
        img{
            width: 46px;
            height: 44px;
            object-fit: cover;
            margin-right: 14px;
        }
    }

     .primary{
        margin-right: 30px;
    }
    .outsideBtn{
        margin-bottom: 20px;
    }
    .adrTips{
        background: #F3FBFB;
        padding:16px 30px;
        color:#4A4A4A;
        font-size: 24px;
        line-height: 40px;
    }
    .myadrcontent{
            width:670px;
            margin-bottom: 50px;
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 10px 0px rgba(0,0,0,0.1);
            border-radius:3px;
            padding-top:50px;
            padding-bottom:50px;
            margin-top:30px;
            margin-left: 5px;
        p{
            font-size: 30px;
            margin-bottom: 20px;
            margin-top:20px;
            margin-left:50px; 
        }
    }
    .mysendBtn{
        margin-top:35px!important;
    }
    .fr{
        float: right;
        margin-top: 30px;
        margin-left:20px;

    }
    .containerAdr{
        max-height: 860px;
        padding: 32px;
        position: relative;
        padding-bottom:60px;
        padding-top: 0px;
        .ctitle{
            line-height: 90px;
            border-bottom:1px solid #EEEEEE;
            font-size: 28px;
            font-weight:500
            }
            &>span{
                position:absolute;
                right:30px;
                top:80px;
                color:#7ADFDF;
            }
            .addr-container{
                max-height: 700px;
                overflow-y: scroll;
            ul li{
                width: 100%;
                display: flex;
                padding-top:32px;

                // align-items: center;
            }
        }
        .close{
            width: 36px;
            height: 36px;
            position: absolute;
            top: 30px;
            right: 30px;
            background: url("/images/public/close.png") no-repeat center;
            background-size: 32px;
        }
        .submit{
            position: absolute;
            bottom: 30px;
            right: 30px;
        }
    }

</style>
